"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateDimensionPerAspectRatio = void 0;
function calculateDimensionPerAspectRatio(inputWidth, padding) {
    if (padding === void 0) { padding = 0; }
    var width;
    var height;
    if (padding > 100) {
        throw new Error('padding should be less than 100');
    }
    if (inputWidth !== 0) {
        inputWidth = Math.round(inputWidth);
    }
    height = (9 * inputWidth) / 16;
    if (padding > 0) {
        height = height - padding;
        width = (16 * height) / 9;
    }
    else {
        width = inputWidth;
    }
    return [width, height];
}
exports.calculateDimensionPerAspectRatio = calculateDimensionPerAspectRatio;
//# sourceMappingURL=dimensions.js.map